import { render } from "./ListOrders.vue?vue&type=template&id=270efe8a"
import script from "./ListOrders.vue?vue&type=script&lang=js"
export * from "./ListOrders.vue?vue&type=script&lang=js"

import "./ListOrders.vue?vue&type=style&index=0&id=270efe8a&scope=true&lang=css"

import exportComponent from "/home/atom/Works/renny/rotto-web-admin/Front-End/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__